// extracted by mini-css-extract-plugin
export default {"loading":"_48ajRdHRSTknWA3VZabrbJ"};